module.exports = __webpack_public_path__ + "img/proxima_covid_box.6992edfa.png";